export default __webpack_public_path__ + "static/media/gallery7.b28beb83.jpg";